// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobileUp, [
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.justifyContent("flexEnd"),
            BsCssJs$PrezzeeRibbon.position("absolute"),
            BsCssJs$PrezzeeRibbon.top("zero"),
            BsCssJs$PrezzeeRibbon.left("zero"),
            BsCssJs$PrezzeeRibbon.overflow("hidden"),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
          ]),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.display("block"),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height("auto"),
            BsCssJs$PrezzeeRibbon.position("relative"),
            BsCssJs$PrezzeeRibbon.zIndex(1),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobileUp, [
                  BsCssJs$PrezzeeRibbon.width("auto"),
                  BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
                ])
          ])
    ]);

var Styles = {
  container: container
};

function FullWidthHero__Image(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    container,
                    className$1
                  ])
            });
}

var make = FullWidthHero__Image;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
